<template>
  <div class="schedule-info-lesson">
    <Sect title="时间">
      <div class="flex time">
        <div>
          <p>{{ lessonDate }}</p>
          <p>{{ lessonTime }}</p>
        </div>
        <p
          @click="isOneHourBefore ? $emit('attendance', 4) : $toastError('课前 1 小时内无法请假')"
          class="leave"
          v-if="
            schedule.is_attendance &&
              (!attendance || attendance.type.status !== 4) &&
              isOneHourBefore
          "
        >
          <i class="anyteachicon anyteach-clock1" />
          <span>请假</span>
        </p>
      </div>
    </Sect>
    <Sect v-if="attendance && attendance.type.status !== 1" title="出勤">
      <div class="flex time">
        <p>{{ attendance.type.name }}</p>
        <p
          @click="isOneHourBefore ? $emit('attendance', 1) : $toastError('课前 1 小时内无法更改')"
          class="leave"
          v-if="attendance.type.status === 4 && isOneHourBefore"
        >
          <i class="anyteachicon anyteach-revert" />
          <span>取消请假</span>
        </p>
      </div>
    </Sect>
    <Sect title="老师">
      <div class="teacher">
        <div class="img" :style="$bgd(data.teacher.gravatar)" />
        <span>{{ data.teacher.name }}</span>
      </div>
    </Sect>
    <Sect
      v-if="
        data.type === 3 &&
          (data.student_exam ||
            $moment()
              .subtract(1, 'week')
              .isBefore($moment(data.start_time)))
      "
      title="考试报告"
    >
      <div v-if="data.student_exam" class="flex">
        <p>
          综合评分：{{
            (data.student_exam.fluency +
              data.student_exam.accuracy +
              data.student_exam.pronunciation +
              data.student_exam.listening +
              data.student_exam.communication) /
              5
          }}
          / 5
        </p>
        <router-link tag="a" :to="'/exams/' + data.student_exam.id">
          <i class="anyteachicon anyteach-view" />
          <span>查看</span>
        </router-link>
      </div>
      <p v-else class="disabled">等待老师填写</p>
    </Sect>
    <Sect v-if="data.lessonTitle.length" title="内容">
      <p v-for="item in data.lessonTitle" :key="item.lesson.id">
        {{ item.series.title }} / {{ item.book.title }} / {{ item.unit.title }} /
        {{ item.lesson.title }}
      </p>
    </Sect>
    <Sect v-if="data.is_homework" title="作业">
      <div class="flex">
        <router-link tag="a" :to="'/homework/' + data.student_homework[0].id">
          <i class="anyteachicon anyteach-view" />
          <span>前往查看</span>
        </router-link>
      </div>
    </Sect>
    <Sect v-if="data.room" title="教室">
      <div class="room">
        <a :href="data.room.url">{{ data.room.name }}</a>
        <p>房间号：{{ data.room.number }}</p>
      </div>
    </Sect>
  </div>
</template>

<script>
import Sect from "./Sect"
export default {
  props: ["data", "schedule"],
  components: {
    Sect
  },
  computed: {
    lessonDate() {
      return this.$moment(this.data.start_time).format("YYYY年M月D日 dddd")
    },
    lessonTime() {
      return `${this.$moment(this.data.start_time).format("HH:mm")}-${this.$moment(this.data.end_time).format("HH:mm")}`
    },
    isOneHourBefore() {
      return this.$moment().add(1, "hour").isBefore(this.$moment(this.data.start_time))
    },
    attendance() {
      return this.data.schedule_time_user
    }
  },
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  i {
    margin-right: 3px;
  }
}

.disabled {
  opacity: 0.6;
}
.time {
  .leave {
    color: $blue;
    @include avenir-demi();
    font-size: 0.9rem;
  }
}
.teacher {
  display: flex;
  align-items: center;
  span {
    font-size: 0.9rem;
  }
  .img {
    margin-right: 5px;
    $size: 35px;
    width: $size;
    height: $size;
    border-radius: 100%;
  }
}

.room {
  font-size: 0.9rem;
  p {
    font-size: 0.9rem;
    opacity: 0.6;
  }
}
</style>